<template src="./EnvioMensajes.html"></template>

<script>
export default {
  data() {
    return {
      senderName: "",
      celPhone: '',
      message: "",
    };
  },
  created () {
    console.log('dataPacient', this.dataPacient);;
  },
  methods: {
    cancel() {
      this.senderName = "";
      this.celPhone = 0;
      this.message = "";
    },
  },
  props: {
    dataPacient: {
      type: Object,
      default: ""
    },
  },
};
</script>

<style lang="scss" scoped src="./EnvioMensajes.scss">
</style>


// WEBPACK FOOTER //
// src/components/Mensajes/EnvioMensajes/EnvioMensajes.vue